<template lang="html">

    <body class="billing-info">
        <div class="billing-info__container">
            <h1 class="header-1 billing-info__header">
                Informații de facturare
            </h1>
            <p v-if="user.id === ''">
                Se încarcă datele...
            </p>
            <template v-else>

                <FormUpdateBillingInfo v-if="user.id !== ''" class="billing-info__form"/>

                <a @click="logout()" class="billing-info__disconnect">Deconectare</a>
            </template>
        </div>
    </body>
</template>

<script>
    import FormUpdateBillingInfo from '@/components/forms/Settings/BillingInfo'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        components: {
            FormUpdateBillingInfo
        },
        computed: {
            ...mapGetters({
                user: 'user/user'
            }),
            oneMoreStep() {
                return (this.user && !this.user.address);
            }
        },
        mounted() {
            this.fetchUser();
        },
        methods: {
            ...mapActions({
                fetchUser: 'user/user',
                logout: 'user/logout',
            }),
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/scss/pages/billing-info";
</style>